import React, { Component } from "react";
import { getGoogleMaps } from "../../utils/Utils";

let map;
var overlay;
var loc_center;
var CenterLat;
var CenterLng;
var k_diff = 0.005;
var D_diff = 0.01;
var rot = 0;
const lettersArray = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];
export class TaskHeatMap extends Component {
  state = {
    currentFloor: {},
  };

  componentWillMount = () => {
    const newState = {
      ...this.state,
      currentFloor: this.props.currentBuilding.FloorOverlays[0],
    };

    this.setState(newState);
    const currentFloor = this.props.currentBuilding.FloorOverlays[0];
    CenterLat = currentFloor.CenterLat;
    this.initMap = this.initMap.bind(this);
    CenterLng = currentFloor.CenterLng;
    k_diff = currentFloor.k_diff;
    D_diff = currentFloor.D_diff;
    rot = currentFloor.Rot;
  };

  getWaypoints = (subTaskInstances) => {
    if (typeof subTaskInstances === "object" && subTaskInstances.length !== 0) {
      let points = [];
      subTaskInstances.forEach((subTaskInstance) => {
        if (
          subTaskInstance.SubTask.SubTaskType === "Waypoint" &&
          typeof subTaskInstance.WaypointInstances === "object" &&
          subTaskInstance.WaypointInstances.length !== 0
        ) {
          let startLat = subTaskInstance.WaypointInstances[0].StartLat;
          let startLng = subTaskInstance.WaypointInstances[0].StartLng;
          const endLat = subTaskInstance.WaypointInstances[0].Waypoint.Lat;
          const endLng = subTaskInstance.WaypointInstances[0].Waypoint.Long;
          // let point = {
          //   lat: startLat,
          //   lng: startLng,
          // };
          // points.push(point);
          let point = {
            lat: endLat,
            lng: endLng,
          };
          points.push(point);
        }
      });

      return points;
    }
  };

  componentDidMount = () => {
    let zoomCorrection = 1;
    if (typeof this.props.zoomCorrection === "number") {
      zoomCorrection = this.props.zoomCorrection;
    }
    const currentBuilding = this.props.currentBuilding;
    let googleMapPromise = getGoogleMaps();
    let points = this.getWaypoints(this.props.taskInstance.SubTaskInstances);

    if (!window.google) {
      Promise.all([googleMapPromise]).then((values) => {
        let google = values[0];

        this.initMap = this.initMap.bind(this);

        this.google = google;
        //this.markers = [];

        this.initMap(this.props.mapId, currentBuilding, zoomCorrection, points);
      });
    } else {
      this.initMap(this.props.mapId, currentBuilding, zoomCorrection, points);
    }
  };

  initMap = (mapId, currentBuilding, zoomCorrection, points) => {
    const currentFloor = currentBuilding.FloorOverlays[0];
    loc_center = new window.google.maps.LatLng(
      currentFloor.CenterLat,
      currentFloor.CenterLng
    );
    DebugOverlay.prototype = new window.google.maps.OverlayView();

    let initialize = (points) => {
      var mapOptions = {
        zoom: 18 / zoomCorrection,
        center: loc_center,
        backgroundColor: "#051932",
        disableDefaultUI: true,
        mapTypeId: "satellite",
      };

      map = new window.google.maps.Map(
        document.getElementById(mapId),
        mapOptions
      );

      const customStyled = [
        {
          featureType: "all",
          elementType: "labels",
          stylers: [{ visibility: "off" }],
        },
      ];
      map.set("styles", customStyled);

      var newPointA = new window.google.maps.LatLng(
        CenterLat - k_diff,
        CenterLng - D_diff
      );
      var newPointB = new window.google.maps.LatLng(
        CenterLat + k_diff,
        CenterLng + D_diff
      );
      var bounds = new window.google.maps.LatLngBounds(newPointA, newPointB);
      var srcImage =
        "https://res.cloudinary.com/dx8nclins/image/upload/v1569765645/buildings/fb10989e-942e-4142-8687-e7e903b03cef.png";

      //overlay = new DebugOverlay(bounds, srcImage, map);
      //Rotation marker
      var gradient = [
        //green top darkred bottom

        // baby blue
        "rgba(0,255,255,0)",
        //'rgba(0,255,255,1)',
        //'rgba(0,255,153,1)',
        //'rgba(0,255,102,1)',

        //greensish

        "rgba(0,255,0,1)",
        "rgba(0,204,0,1)",

        //yellowish
        "rgba(255,255,0,1)",
        "rgba(255,153,0,1)",
        "rgba(255,102,0,1)",

        //redish
        "rgba(255,0,51,1)",
        "rgba(204,0,0,1)",
        "rgba(255,0,0,1)",
        "rgba(153,0,0,1)",
        "rgba(153,0,0,1)",
        "rgba(102,0,0,1)",

        //blueish
        "rgba(51,0,255,1)",
        "rgba(51,204,255,1)",
        "rgba(51,102,255,1)",
        "rgba(51,0,255,1)",

        // purpleish

        "rgba(153,0,102,1)",
        "rgba(102,0,102,1)",
        "rgba(51,0,102,1)",
        "rgba(0,0,51,1)",
      ];

      var heatmap = new window.google.maps.visualization.HeatmapLayer({
        data: this.props.dataPoints,
        gradient: gradient,
        opacity: 1,
      });
      heatmap.setMap(map);
      if (typeof points === "object" && points.length !== 0) {
        const linePoints = points;
        points.forEach((point, index) => {
          const location = new window.google.maps.LatLng(point.lat, point.lng);
          const name = lettersArray[index];
          new window.google.maps.Marker({
            position: location,
            title: name,
            label: {
              color: "black",
              fontWeight: "bold",
              text: name,
            },
            map: map,
          });
        });
        let i = 0;
        // for (i = 0; i < linePoints.length; ) {
        //   let polyPoints = [];
        //   polyPoints.push(linePoints[i]);
        //   polyPoints.push(linePoints[i + 1]);
        //   const line = new window.google.maps.Polyline({
        //     path: polyPoints,
        //     geodesic: true,
        //     strokeColor: "#0000FF",
        //     strokeOpacity: 1.0,
        //     strokeWeight: 5,
        //   });
        //   line.setMap(map);
        //   i = i + 2;
        // }
      }
    };

    function DebugOverlay(bounds, image, map) {
      this.bounds_ = bounds;
      this.image_ = image;
      this.map_ = map;
      this.div_ = null;
      this.opacity = 0.5;
      this.setMap(map);
    }

    DebugOverlay.prototype.onAdd = function () {
      //rot = (rot * 180) / Math.PI;
      var div = document.createElement("div");
      div.style.borderStyle = "none";
      div.style.borderWidth = "0px";
      div.style.position = "absolute";
      var img = document.createElement("img");
      img.src = this.image_;
      img.style.width = "100%";
      img.style.height = "100%";
      img.style.opacity = "1";
      img.style.position = "absolute";
      img.style.transform = "rotate(" + rot + "rad)";
      div.appendChild(img);
      this.div_ = div;
      var panes = this.getPanes();
      panes.overlayLayer.appendChild(div);
    };

    DebugOverlay.prototype.draw = function () {
      var overlayProjection = this.getProjection();
      var sw = overlayProjection.fromLatLngToDivPixel(
        this.bounds_.getSouthWest()
      );
      var ne = overlayProjection.fromLatLngToDivPixel(
        this.bounds_.getNorthEast()
      );
      var div = this.div_;
      div.style.left = sw.x + "px";
      div.style.top = ne.y + "px";
      div.style.width = ne.x - sw.x + "px";
      div.style.height = sw.y - ne.y + "px";
      div.style.transform = "rotate(" + rot + "deg)";
    };
    DebugOverlay.prototype.updateVariables = function () {};

    DebugOverlay.prototype.updateBounds = function (bounds) {
      this.bounds_ = bounds;
      this.draw();
    };

    DebugOverlay.prototype.updateRotation = function () {
      rot = (rot * 180) / Math.PI;

      var newPointA = new window.google.maps.LatLng(
        CenterLat - k_diff,
        CenterLng - D_diff
      );
      var newPointB = new window.google.maps.LatLng(
        CenterLat + k_diff,
        CenterLng + D_diff
      );
      var newBounds = new window.google.maps.LatLngBounds(newPointA, newPointB);

      this.bounds_ = newBounds;
      this.draw();
    };

    DebugOverlay.prototype.onRemove = function () {
      this.div_.parentNode.removeChild(this.div_);
      this.div_ = null;
    };

    initialize(points);
    //google.maps.event.addDomListener(window, 'load', initialize);
  };

  render() {
    const styles = {
      container: {
        height: this.props.height,
        width: this.props.width,
        //display: 'flex',
        //flexDirection: 'column',
      },
    };
    return <div id={this.props.mapId} style={styles.container} />;
  }
}

export default TaskHeatMap;
